import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Typography, makeStyles } from "@material-ui/core";

import { api } from "../../../../services";
import { COLORS } from "../../../../theme/colors";
import { Button } from "../../../../components/base";
import { UnrealizedSource } from "./UnrealizedSource";
import EvImg from "../../../../assets/images/unrealized/ev.svg";
import SolarImg from "../../../../assets/images/unrealized/solar.svg";
import BatteryImg from "../../../../assets/images/unrealized/battery.svg";
import NewPowerAssetImg from "../../../../assets/images/unrealized/newPowerAsset.svg";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 300,
    fontSize: "1.1rem",
  },
  investmentCostContainer: {
    width: "fit-content",
    marginLeft: theme.spacing(2.5),
  },
  breakdownCol: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(5),
  },
}));

export const ToInstall = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    api.get("/praas/v1/unrealized/to-install/").then((resp) => setData(resp.data));
  }, []);

  const getSource = (item) => {
    switch (item.name) {
      case "batteries":
        return (
          <UnrealizedSource
            img={BatteryImg}
            imgBorderColor={COLORS.majorelleBlue}
            assetName="Batteries"
            perYear={item.per_year}
            per20Y={item.per_20y}
          />
        );
      case "solar":
        return (
          <UnrealizedSource
            img={SolarImg}
            imgBorderColor={COLORS.lightYellow}
            assetName="Solar system"
            perYear={item.per_year}
            per20Y={item.per_20y}
          />
        );
      case "ev":
        return (
          <UnrealizedSource
            img={EvImg}
            imgBorderColor={COLORS.cian}
            assetName="EV Charging"
            perYear={item.per_year}
            per20Y={item.per_20y}
          />
        );
      case "new":
        return (
          <UnrealizedSource
            img={NewPowerAssetImg}
            imgBorderColor="#B7EBBC"
            assetName="New Power Asset"
            perYear={item.per_year}
            per20Y={item.per_20y}
          />
        );
      default:
        return (
          <UnrealizedSource
            img={BatteryImg}
            assetName="Batteries"
            perYear={item.per_year}
            per20Y={item.per20Y}
          />
        );
    }
  };

  return (
    <Grid className={classes.breakdownCol} item xs={12} sm={8}>
      <Grid container>
        <Typography className={classes.title}>POWER ASSETS TO INSTALL -</Typography>
        <Typography className={classes.title} style={{ color: COLORS.green, marginLeft: 4 }}>
          HOW MUCH YOU CAN EARN?
        </Typography>
      </Grid>

      {data ? (
        <Grid container id="power-assets-to-install">
          {data.map((item, index) => (
            <Grid key={index} item xs={6}>
              {getSource(item)}
            </Grid>
          ))}
        </Grid>
      ) : null}

      <Grid container alignItems="center">
        <Button text="INCREASE YOUR POWER REVENUES" next />
        <Grid className={classes.investmentCostContainer} container>
          <Typography variant="h4" style={{ color: COLORS.green }}>
            Your investment & operation costs:
          </Typography>
          <Typography
            style={{
              color: COLORS.green,
              fontWeight: "bold",
              fontSize: 40,
              lineHeight: "10px",
            }}
          >
            {currencySymbol}0
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
